export const getDeleteInvoiceTemplateModalId = (invoiceTemplateId: string) =>
  `${invoiceTemplateId}-delete-template-modal`
